import React, { useState, useEffect } from "react";
import {connect} from "react-redux";

import DashboardPage from "./TrackerDashboard";
import {getPositions, getStatus, changeLabel} from "../../redux/tracker/trackerActions";

import { Client, TRACKER, GEOFENCING, PROJECT } from "../../service/Client"

const DashboardContainer = props => {
	const client = new Client()

	const [initialData, setInitialData] = useState(null);
	const [dataError, setDataError] = useState(false);
	const [dataLoaded, setDataLoaded] = useState(false);

	const saveArea = (geofencingAreaDto) => {
		return client.post(`${TRACKER}/${PROJECT}/${props.project.id}/${GEOFENCING}`, { body: geofencingAreaDto})
			.then(resp => resp.data)
			.catch(error => console.error(error));
	}

	const updateArea = (geofencingAreaDto) => {
		return client.update(`${TRACKER}/${PROJECT}/${props.project.id}/${GEOFENCING}/${geofencingAreaDto.id}`, { body: geofencingAreaDto})
			.then(resp => resp.data)
			.catch(error => console.error(error));
	}

	const deleteArea = (geofencingAreaDto) => {
		return client.delete(`${TRACKER}/${PROJECT}/${props.project.id}/${GEOFENCING}/${geofencingAreaDto.id}`)
			.then(resp => resp)
			.catch(e => console.error(e.message))
	}

	const getAreas = () => {
		return client.get(`${TRACKER}/${PROJECT}/${props.project.id}/${GEOFENCING}`)
			.then(resp => resp.data)
			.catch(error => console.error('Error fetching geofencingAreas', error))
	}

	useEffect(() => {
		getAreas()
			.then(resp => setInitialData(resp)
			)
			.then(() => setDataLoaded({
				loaded: true,
			}))
			.catch(e => setDataError({
				error: true,
			}))
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return <DashboardPage
				{...props}
				onSubmit={saveArea}
				onUpdate={updateArea}
				onDelete={deleteArea}
				getAreas={getAreas}
				initialData={initialData}
				dataLoaded={dataLoaded}
				dataFetchingError={dataError}
			/>
}

const mapStateToProps = ({tracker, session, users}) => ({
	status: tracker.status,
	loading:tracker.loading,
	success:tracker.success,
	error:tracker.error,
	positions:tracker.devices,
	project:session.project,
	user:users.data
});

const mapDispatchToProps = {
	getPositions,
	getStatus,
	changeLabel
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);
